import React, { useState, useEffect, useFocus, useRef } from 'react'
import { Form, Button } from 'react-bootstrap'
import Layout from '../Layout/Layout.js';
import DataTable from 'react-data-table-component';
import { APIUrl } from '../../Helper/APIUrl';
import { SnackbarProvider, useSnackbar } from "notistack";
import { GetStates, GetCities, MasterAPIHelper } from '../../Helper/MasterAPIHelper.js';
import { Link } from 'react-router-dom';

function PageURLMaster() {
    const Token = JSON.parse(localStorage.getItem('tcn'));
    const localStorageUserId = JSON.parse(localStorage.getItem('userid'));

    const { enqueueSnackbar } = useSnackbar();

    //API : Base Url + Controller Name
    const AAuthorizationsURL = APIUrl.AAuthorizations;
    const AppUsersURL = APIUrl.Ausers;
    const SZTYpeURL = APIUrl.SZType;
    const CMenuURL = APIUrl.CMenu;




    //Values to be set
    const [State, setState] = useState("");
    const [StateIsoCode, setStateIsoCode] = useState("0");
    const [City, setCity] = useState("");
    const [CityId, setCityId] = useState(0);
    const [PropertyType, setPropertyType] = useState("");
    const [PropertyFor, setPropertyFor] = useState("");
    const [PageTitle, setPageTitle] = useState("");
    const [PageURL, setPageURL] = useState("");
    const [CreatedBy, setCreatedBy] = useState(localStorageUserId);

    const [StateFilter, setStateFilter] = useState("");
    const [StateIsoCodeFilter, setStateIsoCodeFilter] = useState("");
    const [CityFilter, setCityFilter] = useState("");

    const [lstStates, setlstStates] = useState([]);
    const [lstCities, setlstCities] = useState([]);
    const [lstStatesFilter, setlstStatesFilter] = useState([]);
    const [lstCitiesFilter, setlstCitiesFilter] = useState([]);
    const [zsection, setzsection] = useState([]);
    const [SectionId, setSectionId] = useState(0);

    //Use Ref for Focus
    const StateRef = useRef(null);
    const CityRef = useRef(null);
    const CategoryRef = useRef(null);
    const PropertyTypeNameRef = useRef(null);
    const PropertyForRef = useRef(null);
    const PageTitleRef = useRef(null);
    const PageURLRef = useRef(null);

    //Table and Filteration
    const [search, setsearch] = useState("");
    const [lstURLMaster, setlstURLMaster] = useState([]);
    const [filterURLMaster, setfilterURLMaster] = useState([]);



    const [PropertyTypeLst, setPropertyTypeLst] = useState([]);


    //Edit Populates States
    const [edit, setEdit] = useState(false);
    const [returnId, setreturnId] = useState(0);


    // Safe JSON parse helper to avoid "Unexpected end of JSON input"
    const parseJSON = async (response) => {
        try {
            const text = await response.text();
            if (!text) return null;
            return JSON.parse(text);
        }
        catch (err) {
            console.warn('Failed to parse JSON response', err);

            return null;
        }
    }

    const getAllZSections = async () => {
        try {
            const response = await fetch(APIUrl.ZSections + 'GetAllZSections', {
                method: "Post",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify({})
            });

            const result = await parseJSON(response);
            if (result?.data != null) {
                const filterData = result.data.filter(x => x.PropertyCategoryTag == "Category")
                setzsection(filterData);
            }
        }
        catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {


        const getAllState = async () => {
            try {
                const response = await fetch(APIUrl.State + 'GetAllState', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${Token}`
                    }
                });

                const result = await response.json();
                if (result && result.data !== null) {
                    const states = Array.isArray(result.data) ? result.data : [];
                    setlstStates(states);
                    setlstStatesFilter(states);
                }
            } catch (error) {
                console.log(error);
            }
        };

        getAllState();

        getAllPageURLMaster();
        getAllZSections();
    }, [])

    useEffect(() => {
        const fetchData = async (sectionId) => {
            debugger
            const alldata = await MasterAPIHelper.GetAllSZTypeforWeb();

            const alteredData = alldata.filter((x) => x.SectionId == sectionId);

            setPropertyTypeLst(alteredData);
        };

        fetchData(SectionId);

    }, [SectionId])

    useEffect(() => {
        const getCitiesByStateId = async (stateId) => {
            try {
                if (!stateId || stateId === '0') {
                    setlstCities([]);
                    setCityFilter([]);
                    return;
                }

                const response = await fetch(APIUrl.Cities + `GetCitiesByStateId/${stateId}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${Token}`
                    },
                    body: JSON.stringify()
                });

                const result = await response.json();
                if (result && result.data !== null) {
                    const cities = Array.isArray(result.data) ? result.data : [];
                    setlstCities(cities);
                    setlstCitiesFilter(cities);
                }
            } catch (error) {
                console.log(error);
            }
        };

        getCitiesByStateId(StateIsoCode);

    }, [StateIsoCode])


    function SubmitURLMaster() {
        debugger
        if (!State || State == undefined || State == "0" || State.length == 0 || StateIsoCode == "0") {
            enqueueSnackbar("Please Select State", { variant: "warning" });
            StateRef.current?.focus();
            return;
        }

        if (!City || City == undefined || City == "0" || City.length == 0 || City == "Select City") {
            enqueueSnackbar("Please Select City", { variant: "warning" });
            CityRef.current?.focus();
            return;
        }

        if (!SectionId || SectionId == "0") {
            enqueueSnackbar("Please choose category", { variant: "warning" });
            CategoryRef.current?.focus();
            return;
        }

        if (!PropertyType || PropertyType == undefined || PropertyType == "0" || PropertyType.length == 0) {
            enqueueSnackbar("Please Select Property Type", { variant: "warning" });
            PropertyTypeNameRef.current?.focus();
            return;
        }

         if (!PropertyFor || PropertyFor == undefined || PropertyFor == "0" || PropertyFor.length == 0) {
            enqueueSnackbar("Please Select Property For", { variant: "warning" });
            PropertyForRef.current?.focus();
            return;
        }


        if (!PageURL || PageURL.length < 3) {
            enqueueSnackbar("Please enter a valid Page URL", { variant: "warning" });
            PageURLRef.current?.focus();
            return;
        }

        try {
            const data = { State, StateIsoCode, City, CityId, PropertyType, PropertyFor, PageURL, CreatedBy }
            fetch(APIUrl.PageURLMaster + 'InsertPageURLMaster',
                {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${Token}`
                    },
                    body: JSON.stringify(data)
                })
                .then((response) => {
                    parseJSON(response).then((result) => {
                        if (result) setreturnId(result.returnID);
                        enqueueSnackbar("Successfully Added", { variant: "success" });
                        getAllPageURLMaster();
                        doEmptyStates();
                    })
                })
        }
        catch (error) {
            console.log(error);
        }



    }

    function doEmptyStates() {
        setState("Select State");
        setStateIsoCode("0");
        setCity("Select City");
        setCityId("0");
        setSectionId("0");
        setPropertyType("0");
        setPropertyFor("0");
        setPageTitle("");
        setPageURL("");

        setEdit(false)
    }

    const getAllPageURLMaster = async () => {
        try {
            const response = await fetch(APIUrl.PageURLMaster + 'GetAllPageURLMaster', {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify()
            });

            const result = await parseJSON(response);

            if (result.Message == "Success") {
                setlstURLMaster(result.data);
                setfilterURLMaster(result.data);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const activateDeactivePageURLMaster = async (Id, Value) => {
        try {
            debugger;
            let data = { Value }
            fetch(APIUrl.PageURLMaster + 'ActivateDeactivatePageURLMaster/' + Id,
                {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${Token}`
                    },
                    body: JSON.stringify(data)
                })
                .then((response) => {
                    parseJSON(response).then((result) => {
                        if (result) setreturnId(result.returnID);

                        getAllPageURLMaster();
                        doEmptyStates();
                        Value == "activate" ?
                            enqueueSnackbar("Successfully Activated", { variant: "success" })
                            :
                            enqueueSnackbar("Successfully Dectivated", { variant: "warning" });

                    })
                })
        }
        catch (error) {
            console.log(error);
        }
    };

    const DeleteAuthorizations = async (Id) => {
        try {
            fetch(AAuthorizationsURL + 'DeleteAAuthorizations/' + Id,
                {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${Token}`
                    },
                })
                .then((response) => {
                    parseJSON(response).then((result) => {
                        if (result && result.returnID != null) {
                            // getAllAuthorization();
                            enqueueSnackbar("Successfully Deleted", { variant: "success" })
                        }
                    })
                })
        }
        catch (error) {
            console.log(error);
        }
    };

    const coloumn = [
        {
            name: "SNo.",
            width: "60px",
            selector: (row, index) => index + 1
        },
        {
            name: "Detail",
            selector: (row) =>
                row.IsDetailPage ?
                    <Link to={`/pagedetail?id=${row.URLId}`} target="_blank">
                        <div className="group w-10 h-10 rounded-full flex items-center justify-center bg-gradient-to-br from-emerald-100 to-lime-100 ring-1 ring-emerald-200 shadow-sm transition-all duration-300 hover:scale-110 hover:shadow-lg hover:from-emerald-500 hover:to-lime-500 hover:ring-emerald-400 cursor-pointer" style={{ margin: "10px" }}>

                            <i className="fa fa-info text-[#44a720] transition-colors duration-800 group-hover:text-white" aria-hidden="true"> </i>
                        </div>
                    </Link> : <Link to={`/pagedetail?id=${row.URLId}`} target="_blank">
                        <div className="group w-10 h-10 rounded-full flex items-center justify-center bg-gradient-to-br from-yellow-100 to-amber-100 ring-1 ring-yellow-200 shadow-sm transition-all duration-300 hover:scale-110 hover:shadow-lg hover:from-yellow-500 hover:to-amber-500 hover:ring-yellow-400 cursor-pointer" style={{ margin: "10px" }}>
                            <i className="fa fa-info text-yellow-600 transition-colors duration-800 group-hover:text-white" aria-hidden="true"></i>
                        </div>
                    </Link>,
            sortable: true,
            reorder: true
        },
        {
            name: "TOC",
            selector: (row) =>
                row.IsTOC ?
                    <Link to={`/toc?id=${row.URLId}`} target="_blank">
                        <div className="group w-10 h-10 rounded-full flex items-center justify-center bg-gradient-to-br from-emerald-100 to-lime-100 ring-1 ring-emerald-200 shadow-sm transition-all duration-300 hover:scale-110 hover:shadow-lg hover:from-emerald-500 hover:to-lime-500 hover:ring-emerald-400 cursor-pointer" style={{ margin: "10px" }}>
                            <i className="fa fa-list text-[#44a720] transition-colors duration-800 group-hover:text-white" aria-hidden="true"> </i>
                        </div>
                    </Link>
                    :
                    <Link to={`/toc?id=${row.URLId}`} target="_blank">
                        <div className="group w-10 h-10 rounded-full flex items-center justify-center bg-gradient-to-br from-yellow-100 to-amber-100 ring-1 ring-yellow-200 shadow-sm transition-all duration-300 hover:scale-110 hover:shadow-lg hover:from-yellow-500 hover:to-amber-500 hover:ring-yellow-400 cursor-pointer" style={{ margin: "10px" }}>
                            <i className="fa fa-list text-yellow-600 transition-colors duration-800 group-hover:text-white" aria-hidden="true"> </i>
                        </div>
                    </Link>,
        },
        {
            name: "FAQ",
            selector: (row) =>
                row.IsFAQ ?
                    (<Link to={`/faq?id=${row.URLId}`} target="_blank">
                        <div className="group w-10 h-10 rounded-full flex items-center justify-center bg-gradient-to-br from-emerald-100 to-lime-100 ring-1 ring-emerald-200 shadow-sm transition-all duration-300 hover:scale-110 hover:shadow-lg hover:from-emerald-500 hover:to-lime-500 hover:ring-emerald-400 cursor-pointer" style={{ margin: "10px" }}>
                            <i className="fa fa-question text-[#44a720] transition-colors duration-800 group-hover:text-white" aria-hidden="true"> </i>
                        </div></Link>)
                    :
                    (<Link to={`/faq?id=${row.URLId}`} target="_blank">
                        <div className="group w-10 h-10 rounded-full flex items-center justify-center bg-gradient-to-br from-yellow-100 to-amber-100 ring-1 ring-yellow-200 shadow-sm transition-all duration-300 hover:scale-110 hover:shadow-lg hover:from-yellow-500 hover:to-amber-500 hover:ring-yellow-400 cursor-pointer" style={{ margin: "10px" }}>
                            <i className="fa fa-question text-yellow-600 transition-colors duration-800 group-hover:text-white" aria-hidden="true"> </i>
                        </div></Link>),
            sortable: true,
            reorder: true
        },
        {
            name: "Metas",
            selector: (row) =>
                row.IsMeta ?
                    (<Link to={`/meta?id=${row.URLId}`} target="_blank">
                        <div className="group w-10 h-10 rounded-full flex items-center justify-center bg-gradient-to-br from-emerald-100 to-lime-100 ring-1 ring-emerald-200 shadow-sm transition-all duration-300 hover:scale-110 hover:shadow-lg hover:from-emerald-500 hover:to-lime-500 hover:ring-emerald-400 cursor-pointer" style={{ margin: "10px" }}>
                            <i className="fa fa-lastfm text-[#44a720] transition-colors duration-800 group-hover:text-white" aria-hidden="true"> </i>
                        </div></Link>)
                    :
                    (<Link to={`/meta?id=${row.URLId}`} target="_blank">
                        <div className="group w-10 h-10 rounded-full flex items-center justify-center bg-gradient-to-br from-yellow-100 to-amber-100 ring-1 ring-yellow-200 shadow-sm transition-all duration-300 hover:scale-110 hover:shadow-lg hover:from-yellow-500 hover:to-amber-500 hover:ring-yellow-400 cursor-pointer" style={{ margin: "10px" }}>
                            <i className="fa fa-lastfm text-yellow-600 transition-colors duration-800 group-hover:text-white" aria-hidden="true"> </i>
                        </div></Link>),
            sortable: true,
            reorder: true
        },
        {
            name: "Tags",
            selector: (row) =>
                row.IsTag ?
                    (<Link to={`/tag?id=${row.URLId}`} target="_blank">
                        <div className="group w-10 h-10 rounded-full flex items-center justify-center bg-gradient-to-br from-emerald-100 to-lime-100 ring-1 ring-emerald-200 shadow-sm transition-all duration-300 hover:scale-110 hover:shadow-lg hover:from-emerald-500 hover:to-lime-500 hover:ring-emerald-400 cursor-pointer" style={{ margin: "10px" }}>
                            <i className="fa fa-tags text-[#44a720] transition-colors duration-800 group-hover:text-white" aria-hidden="true"> </i>
                        </div></Link>)
                    :
                    (<Link to={`/tag?id=${row.URLId}`} target="_blank">
                        <div className="group w-10 h-10 rounded-full flex items-center justify-center bg-gradient-to-br from-yellow-100 to-amber-100 ring-1 ring-yellow-200 shadow-sm transition-all duration-300 hover:scale-110 hover:shadow-lg hover:from-yellow-500 hover:to-amber-500 hover:ring-yellow-400 cursor-pointer" style={{ margin: "10px" }}>
                            <i className="fa fa-tags text-yellow-600 transition-colors duration-800 group-hover:text-white" aria-hidden="true"> </i>
                        </div></Link>),
            sortable: true,
            reorder: true
        },
        // {
        //     name: "Link Page",
        //     selector: (row) =>
        //         row.IsLinkPage ?
        //             (<Link to={`/linkpage?id=${row.URLId}`} target="_blank">
        //                 <div className="group w-10 h-10 rounded-full flex items-center justify-center bg-gradient-to-br from-emerald-100 to-lime-100 ring-1 ring-emerald-200 shadow-sm transition-all duration-300 hover:scale-110 hover:shadow-lg hover:from-emerald-500 hover:to-lime-500 hover:ring-emerald-400 cursor-pointer" style={{ margin: "10px" }}>
        //                     <i className="fa fa-paper-plane text-[#44a720] transition-colors duration-800 group-hover:text-white" style={{ color: "#44a720" }} aria-hidden="true"> </i>
        //                 </div></Link>)
        //             :
        //             (<Link to={`/linkpage?id=${row.URLId}`} target="_blank">
        //                 <div className="group w-10 h-10 rounded-full flex items-center justify-center bg-gradient-to-br from-yellow-100 to-amber-100 ring-1 ring-yellow-200 shadow-sm transition-all duration-300 hover:scale-110 hover:shadow-lg hover:from-yellow-500 hover:to-amber-500 hover:ring-yellow-400 cursor-pointer" style={{ margin: "10px" }}>
        //                     <i className="fa fa-paper-plane text-yellow-600 transition-colors duration-800 group-hover:text-white" aria-hidden="true"> </i>
        //                 </div></Link>),
        //     sortable: true,
        //     reorder: true
        // },
        {
            name: "Link Preview",
            selector: (row) =>
                row.IsDetailPage && row.IsTOC && row.IsFAQ && row.IsMeta && row.IsTag &&
                (<Link to={"http://askmerealty.in/" + row.PageURL} target="_blank">
                    <div className="group w-10 h-10 rounded-full flex items-center justify-center bg-gradient-to-br from-emerald-100 to-lime-100 ring-1 ring-emerald-200 shadow-sm transition-all duration-300 hover:scale-110 hover:shadow-lg hover:from-emerald-500 hover:to-lime-500 hover:ring-emerald-400 cursor-pointer" style={{ margin: "10px" }}>
                        <i className="fa fa-paper-plane text-[#44a720] transition-colors duration-800 group-hover:text-white" style={{ color: "#44a720" }} aria-hidden="true"> </i>
                    </div></Link>),
            sortable: true,
            reorder: true,
            width: "120px"
        },
        {
            name: "Page URL",
            selector: (row) => row.PageURL,
            sortable: true,
            reorder: true,
            width: "300px"
        },
        {
            name: "Property For",
            selector: (row) => row.PropertyFor,
            sortable: true,
            reorder: true,
            width: "300px"
        },
        {
            name: "Property Type Name",
            selector: (row) => row.PropertyTypeName,
            sortable: true,
            reorder: true,
            width: "200px"
        },
        {
            name: "City",
            selector: (row) => row.City,
            sortable: true,
            reorder: true,
            width: "150px"
        },
        {
            name: "State",
            selector: (row) => row.State,
            sortable: true,
            reorder: true,
            width: "150px"
        },
        {
            name: <strong>Activated/Deactivated</strong>,
            width: "180px",
            selector: (row) => row.IsActive ? <label class="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">Activated</label> : <label class="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800">Deactivated</label>,
        },
        {
            name: "Action",
            width: "200px",
            cell: row =>
                <div>
                    {
                        <>
                            {
                                !row.IsActive
                                    ?
                                    <Button onClick={() => activateDeactivePageURLMaster(row.URLId, "activate")} data-tip="Click to Activate User" className="text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2"  ><i class="fa fa-toggle-off" aria-hidden="true"></i></Button>
                                    :
                                    <Button onClick={() => activateDeactivePageURLMaster(row.URLId, "deactivate")} data-tip="Click to Deactivate User" className="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-4 py-2"><i class="fa fa-toggle-on" aria-hidden="true"></i></Button>
                            }
                        </>
                    }
                    {/* &nbsp;&nbsp;

                    <Button onClick={() => DeleteAuthorizations(row.AuthId)} data-tip="Click to Delete" className="text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2"><i class="fa fa-trash" aria-hidden="true"></i></Button>
                 */}
                </div>
        }
    ];

    useEffect(() => {
        const query = (search || "").toLowerCase();

        const result = lstURLMaster.filter((x) => {
            const searchableValues = [
                x?.PageTitle,
                x?.PageURL,
                x?.PropertyTypeName,
                x?.PropertyFor,
                x?.City,
                x?.State,
            ];

            return searchableValues.some((value) =>
                String(value || "").toLowerCase().includes(query)
            );
        });

        setfilterURLMaster(result);
    }, [search, lstURLMaster]);

    useEffect(() => {
        if (StateIsoCodeFilter) {
            const filteredCities = lstCitiesFilter.filter(city => city.stateCode === StateIsoCodeFilter);
            setCityFilter("Select City");
            setfilterURLMaster(lstURLMaster.filter(x => x.StateIsoCode === StateIsoCodeFilter));
        }
        else {
            setCityFilter("Select City");
            setfilterURLMaster(lstURLMaster);
        }
    }, [StateIsoCodeFilter]);

    useEffect(() => {
        if (CityFilter && CityFilter !== "Select City") {
            setfilterURLMaster(lstURLMaster.filter(x => x.City === CityFilter));
        }
        else {
            setfilterURLMaster(lstURLMaster);
        }
    }, [CityFilter]);

    const tableData = { coloumn, filterURLMaster };

    return (
        <div>
            <Layout>
                <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
                    <div className="space-y-6">
                        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                            <h2 className="text-xl font-semibold text-gray-900 mb-6">
                                Page URL Master
                            </h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label htmlFor="role" className="block text-sm font-medium text-gray-700 mb-2">
                                        State
                                    </label>
                                    <select
                                        ref={StateRef}
                                        onChange={(e) => {
                                            setStateIsoCode(e.target.value);
                                            setState(e.target.selectedOptions[0].text);
                                        }}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                        value={StateIsoCode}
                                    >
                                        <option value="0">Select State</option>
                                        {
                                            Array.isArray(lstStates)
                                                ?
                                                lstStates.map((dis, index) => {
                                                    const stateId = dis.StateId ?? dis.id ?? dis.isoCode ?? '0';
                                                    const stateName = dis.StateName || dis.State || dis.name || '';
                                                    return (
                                                        <option key={stateId} value={stateId}>{stateName}</option>
                                                    )
                                                })
                                                :
                                                "None"
                                        }
                                    </select>
                                </div>

                                <div>
                                    <label htmlFor="role" className="block text-sm font-medium text-gray-700 mb-2">
                                        City
                                    </label>
                                    <select
                                        ref={CityRef}
                                        value={CityId}
                                        onChange={(e) => {
                                            setCity(e.target.selectedOptions[0].text);
                                            setCityId(e.target.value);
                                        }}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                    >
                                        <option value="0">Select City</option>
                                        {
                                            Array.isArray(lstCities)
                                                ?
                                                lstCities.map((dis, index) => {
                                                    const cityId = dis.CityId ?? dis.id ?? dis.isoCode ?? index;
                                                    const cityName = dis.CityName || dis.City || dis.name || '';
                                                    return (
                                                        <option key={cityId} value={cityId} data-id={cityId}>
                                                            {cityName}
                                                        </option>
                                                    )
                                                })
                                                :
                                                "None"
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
                                <div>
                                    <label htmlFor="role" className="block text-sm font-medium text-gray-700 mb-2">
                                        Choose Category
                                    </label>
                                    <select
                                        id="role"
                                        name="role"
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                        onChange={(e) => setSectionId(e.target.value)}
                                        value={SectionId}
                                        ref={CategoryRef}
                                    >
                                        <option value="0" selected>Select</option>
                                        {
                                            zsection && zsection !== undefined
                                                ?
                                                zsection.map((dis, index) => {
                                                    return (
                                                        <option value={dis.SectionId} >{dis.SectionName}</option>
                                                    )
                                                })
                                                :
                                                null
                                        }
                                    </select>
                                </div>
                                <div>
                                    <label htmlFor="role" className="block text-sm font-medium text-gray-700 mb-2">
                                        Property Type
                                    </label>
                                    <select
                                        ref={PropertyTypeNameRef}
                                        onChange={(e) => setPropertyType(e.target.value)}
                                        value={PropertyType}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                    >
                                        <option value="0" selected>Select</option>
                                        {
                                            PropertyTypeLst && PropertyTypeLst !== undefined
                                                ?
                                                PropertyTypeLst.map((dis, index) => {
                                                    return (
                                                        <option value={dis.TypeId}>{dis.TypeName}</option>
                                                    )
                                                })
                                                :
                                                "None"
                                        }
                                    </select>
                                </div>
                                <div>
                                    <label htmlFor="role" className="block text-sm font-medium text-gray-700 mb-2">
                                        Property For
                                    </label>
                                    <select
                                        ref={PropertyForRef}
                                        onChange={(e) => setPropertyFor(e.target.value)}
                                        value={PropertyFor}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                    >
                                        <option value="0" selected>Select</option>
                                        <option value="Sell">Sell</option>
                                        <option value="Rent">Rent</option>
                                        <option value="PG">PG</option>
                                    </select>
                                </div>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-1 gap-6 mt-10">
                                {/* <div>
                                    <label htmlFor="role" className="block text-sm font-medium text-gray-700 mb-2">
                                        Page Title
                                    </label>
                                    <input
                                        type='text'
                                        value={PageTitle}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setPageTitle(value);
                                        }}
                                        ref={PageTitleRef}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                        maxLength={100}
                                    />
                                </div> */}

                                <div>
                                    <label htmlFor="role" className="block text-sm font-medium text-gray-700 mb-2">
                                        Page URL
                                    </label>
                                    <input
                                        type='text'
                                        value={PageURL}
                                        ref={PageURLRef}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            const urlValue = value.toLowerCase();
                                            const adjustedURL = urlValue.replace(/\s+/g, '-');
                                            setPageURL(adjustedURL);
                                        }}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                        maxLength={100}
                                    />
                                </div>


                            </div>

                            <div className="flex flex-col sm:flex-row gap-4 mt-3">

                                <Button
                                    className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200 flex items-center justify-center space-x-2"
                                    onClick={() => SubmitURLMaster()}
                                >
                                    <span>Submit</span>
                                </Button>

                                <button
                                    type="button"
                                    onClick={() => doEmptyStates()}
                                    className="px-6 py-3 bg-gray-600 text-white font-medium rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors duration-200"
                                >
                                    Reset
                                </button>

                            </div>
                        </div>
                        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                            <div class="overflow-x-auto">
                                <DataTable
                                    title="Manage Page URL Master"
                                    columns={coloumn}
                                    data={filterURLMaster}
                                    pagination
                                    fixedHeader
                                    fixedHeaderScrollHeight="550px"
                                    selectableRows
                                    selectableRowsHighlight
                                    highlightOnHover
                                    // actions={<button className="btn btn-sm btn-info">Export</button>}                                                
                                    subHeader
                                    subHeaderAlign="right"
                                    subHeaderComponent={
                                        <div style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
                                            <select
                                                onChange={(e) => { setStateIsoCodeFilter(e.target.value); setStateFilter(e.target.selectedOptions[0].text) }}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                                value={StateIsoCodeFilter}
                                            >
                                                <option value="0">Select State</option>
                                                {
                                                    Array.isArray(lstStatesFilter)
                                                        ?
                                                        lstStatesFilter.map((dis, index) => {
                                                            const stateId = dis.StateId ?? dis.id ?? dis.isoCode ?? '0';
                                                            const stateName = dis.StateName || dis.State || dis.name || '';
                                                            return (
                                                                <option key={stateId} value={stateId}>{stateName}</option>
                                                            )
                                                        })
                                                        :
                                                        "None"
                                                }
                                            </select>


                                            <select
                                                onChange={(e) => setCityFilter(e.target.value)}
                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                            >
                                                <option value="0">Select City</option>
                                                {
                                                    Array.isArray(lstCitiesFilter)
                                                        ?
                                                        lstCitiesFilter.map((dis, index) => {
                                                            const cityId = dis.CityId ?? dis.id ?? dis.isoCode ?? index;
                                                            const cityName = dis.CityName || dis.City || dis.name || '';
                                                            return (
                                                                <option key={cityId} value={cityName}>{cityName}</option>
                                                            )
                                                        })
                                                        :
                                                        "None"
                                                }
                                            </select>

                                            <input type="text"
                                                placeholder="search username"
                                                className="w-full sm:w-64 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                                value={search}
                                                onChange={(e) => setsearch(e.target.value)}
                                            />
                                        </div>
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </main>
            </Layout >

        </div >
    )
}

export default PageURLMaster